import { Item } from '../../types'
import * as Styles from './styles'

type Props = {
  items: Array<Item | undefined>
  borderTop?: boolean
}

export const icons = {
  tick: <Styles.TickIcon />,
  template: <Styles.TemplateIcon />,
  writing: <Styles.WritingIcon />,
  word: <Styles.WordIcon />,
  customization: <Styles.CostumizationIcon />,
}

export const StepItems = ({ items, borderTop }: Props) => {
  return (
    <Styles.Items data-testid="step-items">
      {items?.map((item, index) => {
        return (
          <Styles.Item key={item?.header} borderTop={borderTop} data-testid={`step-item-${index}`}>
            {icons[item?.icon as keyof typeof icons]}
            <Styles.ItemText data-testid={`step-item-text-${index}`}>
              <Styles.ItemHeader data-testid={`step-item-header-${index}`}>
                {item?.header}
              </Styles.ItemHeader>
              <Styles.ItemDescription data-testid={`step-item-description-${index}`}>
                {item?.description}
              </Styles.ItemDescription>
            </Styles.ItemText>
          </Styles.Item>
        )
      })}
    </Styles.Items>
  )
}
